import React from "react";
import {
  Box,
  CircularProgress,
  InputAdornment,
  InputLabel,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import type { RepresentativeEmailFieldProps } from "../types";
import useAssistedAffiliationStyles from "../styles";

const RepresentativeEmailField = ({
  value,
  onChange,
  onBlur,
  validation,
  error,
}: RepresentativeEmailFieldProps) => {
  const classes = useAssistedAffiliationStyles();
  const hasError = Boolean(error) ||
    validation.status === "invalid" || validation.status === "error";
  const isValid = validation.status === "valid";
  const message = error || validation.message;
  const icon = validation.status === "validating"
    ? <CircularProgress size={18} />
    : hasError ? <ErrorIcon className={classes.rncErrorAdornment} />
    : isValid ? <CheckCircleIcon className={classes.rncAdornment} /> : null;

  return (
    <Box>
      <InputLabel
        className={classes.fieldLabel}
        shrink
        htmlFor="assisted-affiliation-representativeEmail"
      >
        Correo electrónico<span className={classes.requiredMark}> *</span>
      </InputLabel>
      <TextField
        id="assisted-affiliation-representativeEmail"
        fullWidth
        size="small"
        variant="outlined"
        type="email"
        required
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={hasError}
        helperText={message}
        FormHelperTextProps={{
          role: "status",
          "aria-live": "polite",
          className: isValid ? classes.rncAdornment : undefined,
        }}
        InputProps={{
          endAdornment: icon
            ? <InputAdornment position="end">{icon}</InputAdornment>
            : undefined,
        }}
      />
    </Box>
  );
};

export default RepresentativeEmailField;
